import Vue from 'vue';
export default Vue.component('ed-h2', { name: 'ed-h2'});